'use strict';
import React, {Component} from 'react';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import termStore from '@uw-it-sis/lib-react/lib/TermStore';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {isTrue, isFalse, isEmpty} from '@uw-it-sis/lib-react/lib/Utils';
import registrationDateStore from '@uw-it-sis/lib-react-myplan/lib/RegistrationDateStore';
import TermUtils from '@uw-it-sis/lib-react/lib/TermUtils';
import SimpleState from '@uw-it-sis/lib-react/lib/SimpleState';

import registrationDetailsStore from './RegistrationDetailsStore';
import {NextAction} from "../lib/Constants";

/**
 * The registration button and surrounding widgetry.
 */
class RegisterUW extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.analyticsStore = appStore.getAnalyticsStore();
        this.handleAnalyticsAdd = this.handleAnalyticsAdd.bind(this);
        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this);
        this.buildDoneComponent = this.buildDoneComponent.bind(this);
    }

    componentDidMount() {
        registrationDateStore.mount();
    }

    componentWillUnmount() {
        registrationDateStore.unmount();
    }

    handleRegisterButtonClick() {
        const dataStateSummary = registrationDetailsStore.getCurrentDataStateSummary();
        const selectedCount = registrationDetailsStore.getSelectedRegistrationItemsCount();
        let additionalData = {
            regdCnt: dataStateSummary.registeredCount,
            cIssuesCnt: dataStateSummary.courseIssuesCount,
            sIssuesCnt: dataStateSummary.sectionIssuesCount,
            readyCnt: dataStateSummary.readyCount,
            holdsCnt: dataStateSummary.holdsCount,
            regDate: dataStateSummary.registrationDate,
            selCnt: selectedCount,
            isSeamless: `false`
        }
        this.analyticsStore.addEvent("RegPrev-RegButtonClick", {}, additionalData); // I am keeping the event key name the same
    }

    /**
     * Adds analytics for link clicks.
     *
     * @param eventKey The key name for the link clicked.
     */
    handleAnalyticsAdd(eventKey) {
        this.analyticsStore.addEvent(eventKey,{},{});
    }

    buildDoneComponent() {

        // Get the term data for the selected term id (via component prop)
        let selectedTerm = termStore.get('publishedTerms').find(function (term) {
            return term.id === this.props.selectedTermId;
        }.bind(this));

        let registrationDateMap = undefined;

        if (selectedTerm) {
            registrationDateMap = registrationDateStore.getRegistrationDataForTerm(selectedTerm.codeName);
        }

        let registrationDateTime = undefined;
        let formattedRegistrationDate = '';
        let registrationDate;

        if (!isEmpty(registrationDateMap)) {
            registrationDate = registrationDateMap.date;
            formattedRegistrationDate = registrationDate.format("dddd, MMM D");
            registrationDateTime = registrationDate.add(5, 'hours').add(59, 'minutes');
        }

        let now = moment(appStore.getNow());

        let lastAddDate = undefined;
        if (selectedTerm) {
            selectedTerm.academicCalendar.forEach( function(entry) {

                if (entry.key === 'last_add_day') {
                    // use a time of 11:59pm to check that today's date is past the complete day of the last add day
                    lastAddDate = moment(entry.date + " 23:59", "YYYY-MM-DD hh:mm");
                }
            });
        }
        let formattedRegServicesStartDate;
        if (selectedTerm) {
            let regServicesStartDate = TermUtils.findAcademicCalendarDate(selectedTerm, "RegistrationServicesStart");
            formattedRegServicesStartDate = regServicesStartDate?.format("dddd, MMM D") ?? "";
        }

        let buttonUrl = appStore.getAppAttribute('registration_base_url');

        if (selectedTerm) {
            buttonUrl = buttonUrl + `#${TermUtils.makeTermLinkIdentifierFromTermId(selectedTerm.id)}`
        }
        let buttonRegister =
                <a href={buttonUrl}
                   target="_blank"
                   aria-label="Take me to Register.UW"
                   className={classnames("btn btn-primary btn-inline")}
                   onClick={this.handleRegisterButtonClick}>Take me to Register.UW</a>;


        let buttonComponent =
            <div className={classnames("d-flex justify-content-end")}>
                {buttonRegister}
            </div>;

        if(this.props.data.nextAction === NextAction.REG_SVCS_NOT_OPEN) {
            buttonComponent = null;
        }

        let registrationTiming;
       // console.log("Next Action:"+this.props.data.nextAction);
        // Total 7 states for a student to be in
        // State 1: Past Last Day to Register
        if(now.isAfter(lastAddDate)) {
            registrationTiming =
                <p>
                    <p>The last day to register for {selectedTerm.name} was {lastAddDate.format("dddd, MMM D")}.
                        Please contact your campus registration office for help regarding your current schedule.</p>
                    <ul>
                        <li><a href="https://www.uwb.edu/registration" target="_blank"
                               onClick={() => this.handleAnalyticsAdd("RegPrev-RegistrarBothellLink")}>UW Bothell</a>
                        </li>
                        <li><a href="https://registrar.washington.edu" target="_blank"
                               onClick={() => this.handleAnalyticsAdd("RegPrev-RegistrarSeattleLink")}>UW Seattle</a>
                        </li>
                        <li><a href="http://www.tacoma.uw.edu/node/38232" target="_blank"
                               onClick={() => this.handleAnalyticsAdd("RegPrev-RegistrarTacomaLink")}>UW Tacoma</a></li>
                    </ul>
                </p>
        }
            // State 2: Student is all set to Register and registration window is open
        // TODO: Assumption that NextAction.REGISTERED is set only when student has completed pre-reg and their specific registration window is open
        else if (this.props.data.nextAction === NextAction.REGISTER) {
            registrationTiming =
                <p>Registration is open. You will be able to register online
                    until {lastAddDate.format("dddd, MMM D")}.</p>
        }
            // State 3: Registration is open but student has not completed pre-reg steps
        // TODO: Assumption that ACKNOWLEDGE state is set only when the student can complete pre-registration steps (after the pre-registration window is open)
        else if ((this.props.data.nextAction === NextAction.PREREG || this.props.data.nextAction === NextAction.ACKNOWLEDGE || this.props.data.nextAction === NextAction.ADDRESS) && now.isAfter(registrationDateTime)) {
            registrationTiming =
                <p>You will be able to register online until {lastAddDate.format("dddd, MMM D")}.
                    You have not completed your required pre-registration steps.
                    You must complete your pre-registration steps before you can register.</p>
        }
            // State 4: Registration is not open but pre-reg window is open and student has completed pre-reg steps
        // TODO: Assumption that STUDENT_REG_NOT_OPEN is set after student has completed their pre-reg steps and the registration window is not open for that student
        else if(this.props.data.nextAction === NextAction.STUDENT_REG_NOT_OPEN) {
            registrationTiming =
                <p>Your estimated registration date is {formattedRegistrationDate}.
                    You will be able to register online until {lastAddDate.format("dddd, MMM D")}.</p>
        }
        // State 5: Registration is not open but pre-reg window is open and student has NOT completed pre-reg steps
        else if ((this.props.data.nextAction === NextAction.PREREG || this.props.data.nextAction === NextAction.ACKNOWLEDGE || this.props.data.nextAction === NextAction.ADDRESS) && now.isBefore(registrationDateTime)) {
            registrationTiming =
                <p>Complete Your Required Pre-Registration Steps. Your required pre-registration steps are now
                    available in Registration. You must complete your pre-registration steps before you can
                    register.</p>
        }
            // State 6: Pre-registration window is not open for the student
        // TODO: Assumption that once REG_SVCS_NOT_OPEN ends, the nextAction will switch to ACKNOWLEDGE
        else if (this.props.data.nextAction === NextAction.REG_SVCS_NOT_OPEN) {
            registrationTiming =
                <p>Pre-registration is not open. You can complete your Pre-Registration steps
                    on {formattedRegServicesStartDate} at <a
                        href={buttonUrl}
                        target="_blank"
                        aria-label="Register.UW"
                        onClick={this.handleRegisterButtonClick}>Register.UW</a>.</p>
        }
        // State 7: When blocked show student a message as to where they can go and see the block reasons
        else if (this.props.data.nextAction === NextAction.BLOCK) {
            registrationTiming =
                <p>You are not able to register. Visit Register.UW for more details on your registration blocks.</p>
        }

        return (
            // <Row>
            //     <Col xs={12} sm={7} md={6}>
            <Card bg="purple-light" text="purple" className="mb-3" aria-atomic={true} aria-live="polite" role="alert">
                <Card.Body className="d-grid gap-3">
                    <div>
                        <strong className="d-block h4">Registration Status</strong>
                        {registrationTiming}
                    </div>
                    {buttonComponent}
                </Card.Body>
            </Card>
            //     </Col>
            // </Row>
        );
    }

    render() {
        return <SimpleState state={registrationDateStore.state} doneComponentBuilder={this.buildDoneComponent} name="RegistrationUW"/>
    }

}

RegisterUW.propTypes = {
    selectedTermId: PropTypes.string.isRequired,
    hasIssues: PropTypes.bool.isRequired,
    isEmpty: PropTypes.bool.isRequired,
    hasReady: PropTypes.bool.isRequired,
    readyList: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
};

export default observer(RegisterUW);